<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <path id="패스_3986" data-name="패스 3986" fill="none" d="M0,0H24V24H0Z" />
    <path
      id="mark_chat_unread_FILL1_wght400_GRAD0_opsz24"
      fill="#d5d8dc"
      d="M2,22V4a1.927,1.927,0,0,1,.588-1.413A1.925,1.925,0,0,1,4,2H14.1a5.05,5.05,0,0,0,0,2,4.874,4.874,0,0,0,1.725,2.862A4.834,4.834,0,0,0,19,8a5.1,5.1,0,0,0,1.575-.25A4.675,4.675,0,0,0,22,7v9a2,2,0,0,1-2,2H6Z"
      transform="translate(0 1)"
    />
    <path
      id="mark_chat_unread_FILL1_wght400_GRAD0_opsz24-2"
      data-name="mark_chat_unread_FILL1_wght400_GRAD0_opsz24"
      fill="#ff5c5c"
      d="M19,6a2.893,2.893,0,0,1-2.125-.875A2.893,2.893,0,0,1,16,3,2.893,2.893,0,0,1,16.875.875a3.018,3.018,0,0,1,4.25,0A2.893,2.893,0,0,1,22,3a2.893,2.893,0,0,1-.875,2.125A2.893,2.893,0,0,1,19,6Z"
      transform="translate(0 1)"
    />
    <rect
      id="사각형_6729"
      data-name="사각형 6729"
      fill="#363c43"
      width="2"
      height="2"
      transform="translate(7 10)"
    />
    <rect
      id="사각형_6730"
      data-name="사각형 6730"
      fill="#363c43"
      width="2"
      height="2"
      transform="translate(11 10)"
    />
    <rect
      id="사각형_6731"
      data-name="사각형 6731"
      fill="#363c43"
      width="2"
      height="2"
      transform="translate(15 10)"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
